module.exports = __webpack_public_path__ + "static/img/deco_jin_01.6616887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deco_jin_01.png
// module id = u5wy
// module chunks = 1